export const availableFonts = [
  { value: "Arial", label: "Arial" },
  { value: "Verdana", label: "Verdana" },
  { value: "Helvetica", label: "Helvetica" },
  { value: "Times New Roman", label: "Times New Roman" },
  { value: "Georgia", label: "Georgia" },
  { value: "Poppins", label: "Poppins (Modern)" },
  { value: "Montserrat", label: "Montserrat (Modern)" }
]; 

// Add target audience constants
export const availableTargetAudiences = [
  { value: 'everyone', label: 'Everyone' },
  { value: 'genz', label: 'Gen Z (18-25)' },
  { value: 'millennials', label: 'Millennials (26-40)' },
  { value: 'genx', label: 'Gen X (41-55)' },
  { value: 'boomers', label: 'Boomers (56+)' },
  { value: 'trendsetters', label: 'Trendsetters & Influencers' },
  { value: 'eco-conscious', label: 'Eco-Conscious Shoppers' },
  { value: 'urbanites', label: 'Urban Professionals' },
  { value: 'remote-workers', label: 'Remote Workers & Digital Nomads' },
  { value: 'fitness-enthusiasts', label: 'Fitness Enthusiasts' },
  { value: 'pet-parents', label: 'Pet Parents' },
  { value: 'new-parents', label: 'New Parents' },
  { value: 'students', label: 'Students & Learners' },
  { value: 'creatives', label: 'Creatives & Designers' },
  { value: 'techies', label: 'Tech Lovers' },
  { value: 'fashionistas', label: 'Fashionistas' },
  { value: 'beauty-gurus', label: 'Beauty Gurus' },
  { value: 'travelers', label: 'Adventurous Travelers' },
  { value: 'homebodies', label: 'Homebodies' },
  { value: 'foodies', label: 'Foodies' },
  { value: 'gamers', label: 'Gamers & Streamers' },
  { value: 'seniors', label: 'Active Seniors' },
  { value: 'kids', label: 'Kids & Teens' },
  { value: 'luxury-shoppers', label: 'Luxury Shoppers' },
  { value: 'bargain-hunters', label: 'Bargain Hunters' },
  { value: 'diyers', label: 'DIYers & Makers' },
  { value: 'wellness-seekers', label: 'Wellness Seekers' },
  { value: 'parents', label: 'Parents' },
  { value: 'outdoor-lovers', label: 'Outdoor Lovers' }
]; 